<mat-toolbar *ngIf="mainContextMenu$ | async as contextMenu">
  <app-context-menu [contextMenu]="contextMenu" [additionalDataContext]="{}"></app-context-menu>
</mat-toolbar>
